import React, { forwardRef } from 'react';

import { FloatingSmartTree } from '../../../Floating/FloatingSmartTree';

import { SelectRootContext } from './SelectRootContext';
import { SelectRootFloatingContext } from './SelectRootFloatingContext';
import { useSelectRoot } from './useSelectRoot';
import { useSelectRootFloating } from './useSelectRootFloating';

import type { SelectRootProps, SelectRef } from '../../Select.types';

export const SelectRoot = forwardRef<SelectRef, SelectRootProps>(
    ({ children, onDropdownVisibleChange, ...rest }: SelectRootProps, ref) => {
        const selectRootContextValue = useSelectRoot({
            selectRef: ref,
            onDropdownVisibleChange,
            ...rest
        });
        const rootFloatingContextValue = useSelectRootFloating({
            onDropdownVisibleChange,
            onIsPositionedChange: selectRootContextValue.setIsFloatingDropdownPositioned,
            selectRootContextValue
        });
        return (
            <SelectRootContext.Provider value={selectRootContextValue}>
                <SelectRootFloatingContext.Provider value={rootFloatingContextValue}>
                    <FloatingSmartTree nodeId={rootFloatingContextValue.floatingNodeId}>
                        {children}
                    </FloatingSmartTree>
                </SelectRootFloatingContext.Provider>
            </SelectRootContext.Provider>
        );
    }
);

SelectRoot.displayName = 'SelectRoot';
